const STORAGE_KEY = "pulsewise.module-last-surface.v1";

type Store = Record<string, Record<string, string>>;

function storage(): Pick<Storage, "getItem" | "setItem"> | null {
  try {
    const candidate = globalThis as { localStorage?: Pick<Storage, "getItem" | "setItem"> };
    return candidate.localStorage ?? null;
  } catch {
    return null;
  }
}

function readStore(): Store {
  const local = storage();
  if (local === null) return {};
  try {
    const raw = local.getItem(STORAGE_KEY);
    if (raw === null) return {};
    const parsed: unknown = JSON.parse(raw);
    if (parsed === null || typeof parsed !== "object") return {};
    return parsed as Store;
  } catch {
    return {};
  }
}

export function readLastSurface(workspaceId: string, moduleId: string): string | null {
  return readStore()[workspaceId]?.[moduleId] ?? null;
}

export function writeLastSurface(workspaceId: string, moduleId: string, to: string): void {
  const local = storage();
  if (local === null) return;
  try {
    const store = readStore();
    const workspace = store[workspaceId] ?? {};
    workspace[moduleId] = to;
    store[workspaceId] = workspace;
    local.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    // Quota or private mode: last-used is a convenience, not a contract.
  }
}
